import { DropdownOption } from 'components/final-form/dropdownUtils';
import React, { Component } from "react";
import { MessageSourceProps, withMessages } from 'react-message-source';
import { Checkbox, DropdownProps, Grid, Header, Icon, Table } from 'semantic-ui-react';
import styled from 'styled-components';
import { EpRoleDto, EpUserRoleDto } from 'ts-types/api.types';
import { PxDropdownSc } from 'components/final-form/Select';

const StyledIcon = styled(Icon)`
  cursor: pointer;
`;

const StyledBtnContainer = styled.div`
  margin-bottom: 5px;
  white-space: nowrap !important;

  & i.icon:last-child {
    margin: 0;
  }
`;

const StyledCheckbox = styled(Checkbox)`
  float: right;
  font-size: 12px !important;
`;

const StyledButtons = styled(Grid.Column)`
  padding: 0 !important;
  flex: 5 5 auto;
`;

const StyledTableRight = styled(Grid.Column)`
    padding-right: 1rem !important;
    padding-left: 0 !important;
    flex: 45 45 auto;
`;

const StyledTableLeft = styled(Grid.Column)`
    padding-left: 1rem !important;
    padding-right: 0 !important;
    flex: 45 45 auto;
`;

const StyledTableRow = styled(Table.Row)`
  cursor: pointer;
`;

const ScrollableTableWrapper = styled.div`
  height: 375px;
  overflow-y: auto;
  overflow-x: hidden;
  width: 100%;
  border: 1px solid rgba(34,36,38,.15);
  box-shadow: none;
  border-radius: .28571429rem;
  flex: 50 50 auto;

  & .ui.table {
    border: none;
  }

   & .ui.table thead tr:first-child > th {
      position: sticky !important;
      top: 0;
      z-index: 2;
      background: #fff;
  }

  & .ui.table tbody tr:last-child > td {
      border-bottom: 1px solid rgba(34,36,38,.15)
  }
`;

interface Props extends MessageSourceProps {
  epRoles?: Array<EpRoleDto>,
  epUserRoles?: Array<EpUserRoleDto>,
  mandateOptions: Array<DropdownOption>,
  selectedMandate?: number,
  setSelectedEpUserRoles: (selectedEpUserRoles: Array<EpUserRoleDto>) => void,
  setUpdateUserEpRoles: (updateEpUserRoles: boolean) => void
}

interface State {
  epRoles: Map<string, EpRoleDto>,
  selectedMandate?: number,
  userAddEpRoles: Array<EpUserRoleDto>,
  markedEpRoles: Array<string>,
  updateUserEpRoles: boolean
}

class EpUserRolesSegment extends Component<Props, State> {

  constructor(props: Props) {
    super(props);

    const {epRoles, epUserRoles = [], selectedMandate} = this.props;

    let epRolesMap = new Map<string, EpRoleDto>();
    if (epRoles) {
      epRoles.forEach(role => {
        epRolesMap.set(role.roleId, role);
      });
    }

    this.state = {
      epRoles: epRolesMap,
      selectedMandate: selectedMandate,
      userAddEpRoles: epUserRoles,
      markedEpRoles: [],
      updateUserEpRoles: false
    };
  }

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
    const {epRoles, mandateOptions, setSelectedEpUserRoles, epUserRoles} = this.props;
    const {userAddEpRoles, selectedMandate} = this.state;

    if (prevProps.epRoles !== epRoles && epRoles) {
      let epRolesMap = new Map<string, EpRoleDto>();
      epRoles.forEach(role => {
        epRolesMap.set(role.roleId, role);
      });
      this.setState({
        epRoles: epRolesMap
      });
    }

    if (prevProps.mandateOptions !== mandateOptions) {

      if (prevProps.mandateOptions.length > 0) {
        const diff = [...mandateOptions.filter(mandate => !prevProps.mandateOptions.includes(mandate)),
          ...prevProps.mandateOptions.filter(mandate => !mandateOptions.includes(mandate))];

        if (diff.length > 0) {
          const epUserRoles =
              userAddEpRoles.filter(epUserRole => epUserRole.mandateId !== diff[0].value);

          this.setState({
            userAddEpRoles: epUserRoles
          });
          setSelectedEpUserRoles(epUserRoles);
        }
      }
      const mandate =
          mandateOptions.find(mandate => mandate.value === selectedMandate);

      if (!mandate && mandateOptions.length > 0) {
        this.setState({
          selectedMandate: mandateOptions[0].value
        });
      }

      if (mandateOptions.length === 0) {

        if (epUserRoles && epUserRoles.length > 0) {
          setSelectedEpUserRoles([]);
        }

        this.setState({
          userAddEpRoles: [],
          selectedMandate: undefined
        });
      }
    }
  }

  handleMandateChange = (mandateId: number) => {
    this.setState({
      selectedMandate: mandateId,
      markedEpRoles: []
    });
  };

  markEpRole = (roleId: string) => {
    const {markedEpRoles} = this.state;

    if (!markedEpRoles.includes(roleId)) {
      this.setState({
        markedEpRoles: [...markedEpRoles, roleId]
      });
    } else {

      this.setState({
        markedEpRoles: markedEpRoles.filter(epRole => epRole !== roleId)
      });
    }
  };

  markUnmarkAllEpRoles = (roleIds: Array<string>) => {
    this.setState({
      markedEpRoles: roleIds
    });
  };

  addRemoveEpRole = () => {
    const {setSelectedEpUserRoles} = this.props;
    const {selectedMandate, markedEpRoles = [], userAddEpRoles = []} = this.state;
    const epUserRoleIds = userAddEpRoles
        .filter(epUserRole => epUserRole.mandateId === selectedMandate)
        .map(epUserRole => epUserRole.roleId);

    if (markedEpRoles.length > 0) {
      if (markedEpRoles.some(roleId => epUserRoleIds.includes(roleId))) {
        const filteredEpUserRoles = userAddEpRoles
            .filter(epUserRole => !markedEpRoles.includes(epUserRole.roleId)
                || epUserRole.mandateId !== selectedMandate
            );

        this.setState({
          userAddEpRoles: filteredEpUserRoles,
          markedEpRoles: []
        });
        setSelectedEpUserRoles(filteredEpUserRoles);
      } else if (selectedMandate) {
        const epUserRolesToAdd: Array<EpUserRoleDto> = markedEpRoles.map(roleId => {
          return {
            mandateId: selectedMandate,
            roleId: roleId
          }
        });
        const newEpUserRoles = [...userAddEpRoles, ...epUserRolesToAdd];
        this.setState({
          userAddEpRoles: newEpUserRoles,
          markedEpRoles: []
        });
        setSelectedEpUserRoles(newEpUserRoles);
      }
    }
  };

  render(): React.ReactNode {
    const {updateUserEpRoles} = this.state;
    const {getMessage} = this.props;

    return (
        <React.Fragment>
          <Grid.Row style={{marginTop: "1rem"}}>
            <Grid.Column width={8}>
              <Header>{getMessage("header.navigation.epRoles")}</Header>
            </Grid.Column>
            <Grid.Column width={8}>
              <StyledCheckbox
                  label={getMessage("user.updateUserEpRoles")}
                  onChange={this.setUpdateUserEpRoles}
                  checked={updateUserEpRoles}
                  toggle/>
            </Grid.Column>
          </Grid.Row>
          {updateUserEpRoles ? this.renderEpUserRolesSegment() : ""}
        </React.Fragment>
    );
  }

  renderEpUserRolesSegment = () => {
    const {epRoles, selectedMandate, userAddEpRoles = [], markedEpRoles = []} = this.state;
    const {mandateOptions, getMessage} = this.props;

    let epUserRolesForMandate: Array<string> = [];
    if (selectedMandate && epRoles.size > 0 && userAddEpRoles.length > 0) {
      epUserRolesForMandate = userAddEpRoles
          .filter(epUserRole => epUserRole.mandateId === selectedMandate)
          .map(epUserRole => epUserRole.roleId);
    }

    let selectableEpRolesForMandate: Array<string> = [];
    if (selectedMandate && epRoles.size > 0) {
      epRoles.forEach((epRole, roleId) => {
        if (!epUserRolesForMandate.includes(roleId)) {
          selectableEpRolesForMandate.push(roleId);
        }
      });
    }

    const disabledLeft = markedEpRoles.length === 0
        || !selectedMandate
        || selectableEpRolesForMandate.some(epRole => markedEpRoles.includes(epRole));

    const disabledRight = markedEpRoles.length === 0
        || !selectedMandate
        || epUserRolesForMandate.some(epRole => markedEpRoles.includes(epRole));

    return (
        <>
          <Grid.Row>
            <Grid.Column width={3} verticalAlign="middle">
              {getMessage("user.epRolesForMandate")}:
            </Grid.Column>
            <Grid.Column width={6}>
              <PxDropdownSc
                  value={selectedMandate}
                  onChange={this.onMandateDropdownChange}
                  options={mandateOptions}
                  selection
                  search
                  fluid
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <StyledTableLeft>
              {this.renderTableSegment(getMessage("user.availableEpRoles"), selectableEpRolesForMandate)}
            </StyledTableLeft>
            <StyledButtons textAlign='center' verticalAlign='middle'>
              <StyledBtnContainer>
                <StyledIcon bordered
                            onClick={() => this.markUnmarkAllEpRoles(selectableEpRolesForMandate)}
                            name='clipboard list'
                />
                <StyledIcon bordered
                            onClick={() => this.markUnmarkAllEpRoles(epUserRolesForMandate)}
                            name='clipboard list'
                />
              </StyledBtnContainer>
              <StyledBtnContainer>
                <StyledIcon bordered
                            onClick={() => this.markUnmarkAllEpRoles([])}
                            name='clipboard outline'
                />
                <StyledIcon bordered
                            onClick={() => this.markUnmarkAllEpRoles([])}
                            name='clipboard outline'
                />
              </StyledBtnContainer>
              <StyledBtnContainer>
                <StyledIcon bordered
                            disabled={disabledRight}
                            onClick={this.addRemoveEpRole}
                            name='angle double right'
                />
                <StyledIcon bordered
                            disabled={disabledLeft}
                            onClick={this.addRemoveEpRole}
                            name='angle double left'
                />
              </StyledBtnContainer>
            </StyledButtons>
            <StyledTableRight>
              {this.renderTableSegment(getMessage("user.selectedEpRoles"), epUserRolesForMandate)}
            </StyledTableRight>
          </Grid.Row>
        </>
    )
  };

  onMandateDropdownChange = (e: any, {value}: DropdownProps) => {
    if (value && typeof value === 'number') {
      this.handleMandateChange(value)
    }
  };

  renderTableSegment = (headerText: string, roleIds: Array<string>): React.ReactNode => {
    const {epRoles, markedEpRoles} = this.state;

    return (
        <React.Fragment>
          <Header as='h5'>
            {headerText}:
          </Header>
          <ScrollableTableWrapper>
            <Table celled selectable size='small'>
              <Table.Body>
                {epRoles.size > 0 && roleIds.map((roleId: string) => (
                        <StyledTableRow key={roleId}
                                        onClick={() => this.markEpRole(roleId)}
                                        active={markedEpRoles.includes(roleId)}
                        >
                          <Table.Cell>
                            {
                              // @ts-ignore
                              epRoles.get(roleId).name
                            }
                          </Table.Cell>
                        </StyledTableRow>
                    )
                )}
              </Table.Body>
            </Table>
          </ScrollableTableWrapper>
        </React.Fragment>
    )
  };

  setUpdateUserEpRoles = () => {
    const {updateUserEpRoles} = this.state;
    const {setUpdateUserEpRoles} = this.props;

    setUpdateUserEpRoles(!updateUserEpRoles);
    this.setState({updateUserEpRoles: !updateUserEpRoles});
  };

}

export default withMessages(EpUserRolesSegment);
